import "../styles/quasar/quasar.scss";
import "@quasar/extras/material-icons/material-icons.css";
import Loading from 'quasar/src/plugins/Loading.js';import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';;
import "quasar/dist/quasar.sass"
import "quasar"
import setCssVar from 'quasar/src/utils/set-css-var.js';;

//Primary Color
const gold = '#B39656'
const black = '#140202'
const white = '#FFFFFF'

//Secondary Color
// const oldWhite =  '#FBFBFB';
const darkYellow = '#FC9904'
// const yellow = '#FDCC81'
// const lightYellow = '#F7DEB9'
const lightGold = '#D3C5A5'
// const darkGrey = '#4F4F4F'
// const grey = '#A7A7A7'
const lightGrey = '#D3D3D3'
// const smokeGrey = '#939598'
// const lightestGrey = '#EDEDED'
// const oldLace = '#F7F4EE'
const darkRed = '#8B0303'
// const heartRed = '#D12A4A'
// const red = '#C58181'
// const lightRed = '#DBB9B9'
const darkGreen = '#397167'
// const green = '#9CB8B3'
// const lightGreen = '#C6D4D2'
// const brown = '#685341'

// set primary color 
setCssVar('gold', gold)
setCssVar('black', black)
setCssVar('white', white)

// set secondary color
setCssVar('light-gold', lightGold)
setCssVar('dark-green', darkGreen)
setCssVar('dark-red', darkRed)
setCssVar('dark-yellow', darkYellow)
setCssVar('light-grey', lightGrey)


// To be used on app.use(Quasar, { ... })
export default {
  config: {
  },
  plugins: {
    Loading,
    Notify,
    Dialog
  },
};